import React, { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { apiFetch, formatDateForInput } from "api/Api";
import { useParams, useNavigate, Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import "assets/theme/admin_form.css";

const EditWork = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    project_title: "",
    start_date: "",
    end_date: "",
    description: "",
    estimate_cost: "",
    status: "",
    assign_to: "",
    mobile_no: ""
  });

  // Load Work Data
  const loadWork = async () => {
    try {
      const data = await apiFetch(`leader_admin/get_work_by_id/${id}`);

      setFormData({
        project_title: data.data.project_title || "",
        start_date: formatDateForInput(data.data.start_date),
        end_date: formatDateForInput(data.data.end_date),
        description: data.data.description || "",
        estimate_cost: data.data.estimate_cost || "",
        status: data.data.status || "",
        assign_to: data.data.assign_to || "",
        mobile_no: data.data.mobile_no || ""
      });

    } catch (error) {
      alert(error.message);
    }
  };

  useEffect(() => {
    loadWork();
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  // Update Work
  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {

      await apiFetch(`leader_admin/update_work/${id}`, {
        method: "PUT",
        body: JSON.stringify(formData)
      });

      alert("प्रकल्प माहिती यशस्वीरित्या अद्यतनित झाली.");

      navigate("/projects");

    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="container-fluid mt-4" style={{ fontSize: "0.9rem" }}>

        {/* Header Card */}
        <div className="admin-form-header-card">
          <div className="d-flex align-items-center gap-3">
            <button type="button" onClick={() => navigate(-1)} className="btn-admin-back">
              <FaArrowLeft />
              <span>मागे जा (Back)</span>
            </button>
            <div>
              <h4 className="fw-bold mb-1 text-white">
                ✏️ प्रकल्प संपादन (Edit Project / Work)
              </h4>
              <small className="text-white-50">प्रकल्प माहिती अद्यतनित करा</small>
            </div>
          </div>

          <Link to="/projects" className="btn btn-light btn-sm fw-semibold rounded-pill px-3">
            Project List
          </Link>
        </div>

        <div className="card shadow-lg border-0 rounded-4">
          <div className="card-body">

            <form onSubmit={handleSubmit}>

              <div className="row g-4">

                <div className="col-md-4">
                  <label className="form-label fw-semibold" style={{ fontSize: "0.85rem" }}>प्रकल्प शीर्षक</label>
                  <input
                    type="text"
                    name="project_title"
                    className="form-control"
                    value={formData.project_title}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label fw-semibold" style={{ fontSize: "0.85rem" }}>प्रकल्प सुरू दिनांक</label>
                  <input
                    type="date"
                    name="start_date"
                    className="form-control"
                    value={formData.start_date}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label fw-semibold" style={{ fontSize: "0.85rem" }}>प्रकल्प समाप्त दिनांक</label>
                  <input
                    type="date"
                    name="end_date"
                    className="form-control"
                    value={formData.end_date}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label fw-semibold" style={{ fontSize: "0.85rem" }}>प्रकल्प वर्णन</label>
                  <input
                    type="text"
                    name="description"
                    className="form-control"
                    value={formData.description}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label fw-semibold" style={{ fontSize: "0.85rem" }}>अंदाजे खर्च</label>
                  <input
                    type="number"
                    name="estimate_cost"
                    className="form-control"
                    value={formData.estimate_cost}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label fw-semibold" style={{ fontSize: "0.85rem" }}>प्रकल्प स्थिती</label>

                  <select
                    name="status"
                    className="form-select"
                    value={formData.status}
                    onChange={handleChange}
                  >
                    <option value="">निवडा</option>
                    <option value="complete">पूर्ण</option>
                    <option value="ongoing">प्रगतीमध्ये</option>
                    <option value="pending">प्रलंबित</option>
                  </select>
                </div>

                <div className="col-md-4">
                  <label className="form-label fw-semibold" style={{ fontSize: "0.85rem" }}>सोपविले</label>
                  <input
                    type="text"
                    name="assign_to"
                    className="form-control"
                    value={formData.assign_to}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label fw-semibold" style={{ fontSize: "0.85rem" }}>मोबाईल क्रमांक</label>
                  <input
                    type="tel"
                    name="mobile_no"
                    className="form-control"
                    value={formData.mobile_no}
                    onChange={handleChange}
                  />
                </div>

              </div>

              <div className="mt-4 text-end">
                <button className="btn btn-primary px-5" disabled={loading} style={{ fontSize: "0.85rem" }}>
                  {loading ? "अद्यतनित होत आहे..." : "अद्यतनित करा"}
                </button>
              </div>

            </form>

          </div>
        </div>

      </div>
    </DashboardLayout>
  );
};

export default EditWork;